import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_ANIMATIONS_R4_PRIMING = defineFcm('psf_animations_r4_priming')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share priming animations R4',
		description:
			'Gates the PSF Animations R4 priming experiment via a dynamic experiment name (empty/invalid disables it)',
		template: {
			experimentName: '',
		},
		deprecated: 'FCM no longer in use — safe to delete after 2026-09-10',
	});
